import { FunctionComponent, ReactNode } from "react";
import styles from "./Tag.module.css";
import {
  LabelPairedCircleCheckSmBoldIcon,
  LabelPairedCircleCheckSmRegularIcon,
  LabelPairedCircleExclamationSmBoldIcon,
  LabelPairedCircleExclamationSmRegularIcon,
  LabelPairedCircleInfoSmBoldIcon,
  LabelPairedCircleInfoSmRegularIcon,
  LabelPairedTriangleExclamationSmBoldIcon,
  LabelPairedTriangleExclamationSmRegularIcon,
} from "@deriv/quill-icons/LabelPaired";

export type TagType = {
  className?: string;
  label: string;
  fontWeight?: "regular" | "bold";
  size?: "sm" | "xs" | "md" | "lg";
  state?: "custom" | "danger" | "warning" | "success" | "information";
  style?: "fill" | "outline";
  icon?: ReactNode;
};

const stateIcons = {
  danger: {
    bold: <LabelPairedTriangleExclamationSmBoldIcon />,
    regular: <LabelPairedTriangleExclamationSmRegularIcon />,
  },
  warning: {
    bold: <LabelPairedCircleExclamationSmBoldIcon />,
    regular: <LabelPairedCircleExclamationSmRegularIcon />,
  },
  success: {
    bold: <LabelPairedCircleCheckSmBoldIcon />,
    regular: <LabelPairedCircleCheckSmRegularIcon />,
  },
  information: {
    bold: <LabelPairedCircleInfoSmBoldIcon />,
    regular: <LabelPairedCircleInfoSmRegularIcon />,
  },
};

export const Tag: FunctionComponent<TagType> = ({
  className = "",
  fontWeight = "regular",
  size = "sm",
  state = "custom",
  style = "fill",
  label,
  icon,
}) => {
  const stateIcon = state !== "custom" ? stateIcons[state]?.[fontWeight] : icon;
  const tagId = `quill-tag-${state}`;

  return (
    <div
      className={[styles.root, className, "quill-ui-next-component"].join(" ")}
      data-id={tagId}
      data-fontWeight={fontWeight}
      data-size={size}
      data-state={state}
      data-style={style}
    >
      {stateIcon}
      <span className={styles.label}>{label === "" ? "Label" : label}</span>
    </div>
  );
};

Tag.displayName = "Tag";
export default Tag;
